import React from 'react';
import { reduxForm } from 'redux-form';
import ShoppingLatexTable from './ShoppingLatexTable';
import ShoppingChipaTable from './ShoppingChipaTable';
import CardEmpty from '../../../../../Utils/Cards/CardEmpty';
import { connect } from 'react-redux';

let ShoppingTablesAnnual = props => {
    const { handleSubmit, formValues, data_annual } = props;

    if (!data_annual) {
        return <div>Cargando datos anuales...</div>;
    }

    return (
        <form onSubmit={handleSubmit}>
            <CardEmpty isMarginButtom>
                <div className="col-md-3 p-0 mt-2">
                    <div className="md-12">
                        <h5 className="mb-4">
                            <strong>
                                COSTOS POR COMPRAS DE LÁTEX
                            </strong>
                        </h5>
                    </div>
                </div>
                <ShoppingLatexTable 
                    data_annual={data_annual}
                    change={props.change} 
                    step={props.step || 1}
                    form_values={formValues.values || {}} 
                />
            </CardEmpty>
            
            <CardEmpty isMarginButtom>
                <div className="col-md-3 p-0 mt-2">
                    <div className="md-12">
                        <h5 className="mb-4">
                            <strong>
                                COSTOS POR COMPRAS DE CHIPA
                            </strong>
                        </h5>
                    </div>
                </div>
                <ShoppingChipaTable 
                    data_annual={data_annual}
                    change={props.change} 
                    step={props.step || 1}
                    form_values={formValues.values || {}} 
                />
            </CardEmpty>
        </form>
    );
};

const mapStateToProps = (state) => {
    const formValues = state.form.ShoppingFormAnnual || {};
    return { formValues };
};

ShoppingTablesAnnual = reduxForm({
    form: 'ShoppingFormAnnual'
})(ShoppingTablesAnnual);

export default connect(mapStateToProps)(ShoppingTablesAnnual); 